var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Alerts", { attrs: { "alert-type": "alert_homepage" } }),
      _c("TaxaPodFetestiNavigation"),
      _c(
        "div",
        {
          staticClass: "section d-flex justify-content-center",
          class: { "pb-0": _vm.isLoggedIn && _vm.vehicles },
        },
        [
          _c(
            "div",
            { staticClass: "container container-medium purchase-wrapper" },
            [
              _c(
                "div",
                { staticClass: "text-center pt-2" },
                [
                  _c("Heading", {
                    attrs: {
                      title: _vm.$t("buy_toll"),
                      routeName: "cart",
                      alignment: "text-center",
                    },
                  }),
                  _c("div", [
                    _c("span", { staticClass: "main-text" }, [
                      _vm._v(
                        _vm._s(_vm.$tc("step", 1)) +
                          ": " +
                          _vm._s(_vm.$t("select_type_of_vehicle"))
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "categories",
                  class: { "mb-0": _vm.isLoggedIn && _vm.vehicles },
                },
                [
                  _c(
                    "div",
                    { staticClass: "row mt-4" },
                    _vm._l(_vm.tollCategories, function (item, key) {
                      return _c(
                        "div",
                        { key: key, staticClass: "col-md-3 col-6 item-card" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "toll-category",
                                  params: { id: item.id },
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card",
                                  attrs: { dusk: "cardelem" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center d-flex img-wrapper",
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "cat-icon",
                                        class: _vm.icons[key].icon,
                                        attrs: { alt: "" },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card-body text-center align-items-center d-flex justify-content-center",
                                    },
                                    [
                                      _c("p", { staticClass: "card-text" }, [
                                        _c("small", {
                                          staticClass: "subtitle",
                                          domProps: {
                                            innerHTML: _vm._s(item.desc),
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm.isLoggedIn
        ? [
            _vm.vehicles
              ? [
                  _c("div", { staticClass: "container container-small" }, [
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "div",
                        { staticClass: "heading heading-small" },
                        [
                          _vm._v(_vm._s(_vm.$t("or_pay_for")) + " "),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "my-cars" } } },
                            [_vm._v(_vm._s(_vm.$t("your_vehicles_link")))]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "container container-small" },
                    _vm._l(_vm.vehicles, function (item, key) {
                      return item._category_TPF
                        ? _c(
                            "div",
                            { key: key, staticClass: "cart-item my-3 p-2" },
                            [
                              _c("AddProductForVehicle", {
                                attrs: { vehicle: item, type: "toll" },
                              }),
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    0
                  ),
                  _vm.totalVehiclesPages > 1
                    ? _c(
                        "div",
                        {
                          staticClass: "container container-small text-center",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "heading heading-small" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("see_all_your_vehicles")) +
                                  " "
                              ),
                              _c(
                                "router-link",
                                { attrs: { to: { name: "my-cars" } } },
                                [_vm._v(_vm._s(_vm.$t("here")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : [
            _c("div", { staticClass: "login-section" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "container container-small" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 mb-3" }, [
                      _c("div", { staticClass: "main-text text-center" }, [
                        _vm._v(_vm._s(_vm.$t("or_go_to_your_account_and_buy"))),
                      ]),
                    ]),
                  ]),
                  _c("LoginComponent"),
                ],
                1
              ),
            ]),
          ],
      _c("section", { staticClass: "section-frequent-questions" }, [
        _c(
          "div",
          { staticClass: "container container-small" },
          [
            _c("p", { staticClass: "text-center heading-medium" }, [
              _vm._v(_vm._s(_vm.$t("header_how_does_it_work"))),
            ]),
            _c("HowItWorks", { attrs: { withTitle: false, showBoth: "toll" } }),
          ],
          1
        ),
      ]),
      _vm.cartCount() && _vm.isMobile()
        ? [
            _c("br"),
            _c("br"),
            _c("br"),
            _c("div", { staticClass: "bottom-bar" }, [
              _c(
                "div",
                { staticClass: "container text-center pt-2" },
                [
                  _c("CartSummary"),
                  _c("div", { staticClass: "row align-items-center" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "action-button text-center" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: "cart" } } },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-light",
                                  attrs: { type: "submit" },
                                },
                                [
                                  _vm._v(_vm._s(_vm.$t("see_cart")) + " "),
                                  _c("i", {
                                    staticClass: "fas fa-arrow-right",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex justify-content-center w-100" }, [
      _c("div", { staticClass: "circle" }, [
        _c("p", { staticClass: "text" }, [_vm._v("sau")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }